import React, { useContext, useMemo } from 'react';
import {
  Field,
  SitecoreContext,
  withSitecoreContext,
  LinkFieldValue,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { FaShoppingCart } from 'react-icons/fa';
import { Badge } from '@mui/material';
import { Link } from 'react-router-dom';
import { APIWebstoreContext } from '../../context/globalContext';
import './index.scss';

export type CartProps = WithSitecoreContextProps & {
  fields: {
    Link: Field<LinkFieldValue>;
    Text: Field<string>;
    ButtonText: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

export interface QuantityFieldsProps {
  LOB: string;
  Quantity: number;
}

export interface QuantityFields {
  Totals: Array<QuantityFieldsProps>;
  TotalQuantity: number;
}

export const Cart = ({ fields, sitecoreContext }: CartProps): JSX.Element => {
  const { state } = useContext(APIWebstoreContext);

  const lobParam = useMemo(() => {
    const cartLOBs = state?.cartCounts?.lobCounts;

    for (const lob in cartLOBs) {
      if (cartLOBs[lob] > 0) return lob;
    }
    return null;
  }, [state?.cartCounts?.lobCounts]);

  if (fields) {
    return (
      <div className="cart">
        <>
          <span className="verticalline"></span>
          <Link
            to={{
              pathname: fields?.Link?.value?.href,
              search: lobParam ? `lob=${lobParam}` : '',
            }}
            id={fields?.Link?.value.text}
            className="cartLink"
          >
            <Badge
              id="badge"
              overlap="rectangular"
              badgeContent={state?.cartCounts?.totalCount}
              color="primary"
            >
              <FaShoppingCart className="icon" />
            </Badge>
            <div className="cartText">{fields?.Link.value.text}</div>
          </Link>
        </>
      </div>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(Cart);
